import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'
import {initialQueryState, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../..//..//styles//styles'
import makeAnimated from 'react-select/animated'
import moment from 'moment'
import {locale, addLocale} from 'primereact/api'
import {AnimaCima2} from '../../../../../../../../_metronic/assets/animation/styles'

const PropertiesListFilter = () => {
  const {updateState} = useQueryRequest()
  const intl = useIntl()
  const animatedComponents = makeAnimated()
  const [openFilterWin, setOpenFilterWin] = useState<boolean>(false)
  const [openDatelimit, setOpenDatelimit] = useState<boolean>(false)
  const [openDateexp, setOpenDateexp] = useState<boolean>(false)
  const [openDateemi, setOpenDateemi] = useState<boolean>(false)

  const [project_id, setproject_id] = useState<string | undefined>()
  const [entrepreneur_id, setentrepreneur_id] = useState<string | undefined>()
  const [enterprise_type_id, setenterprise_type_id] = useState<string | undefined>()
  const [enterprise_id, setenterprise_id] = useState<string | undefined>()
  const [license_type_id, setlicense_type_id] = useState<string | undefined>()
  const [license_number, setlicense_number] = useState<string | undefined>()
  const [description, setdescription] = useState<string | undefined>()
  const [entrepreneur_name, setentrepreneur_name] = useState<string | undefined>()
  const [renovation_protocol, setrenovation_protocol] = useState<string | undefined>()
  const [status, setstatus] = useState<string | undefined>()
  const [field_id, setfield_id] = useState<[string] | undefined>()

  const [issue_date, setissue_date] = useState<Date | Date[] | undefined>(undefined)
  const [issue_dateD, setissue_dateD] = useState<Date | Date[] | undefined>(undefined)

  const [issue_date_between, setissue_date_between] = useState<Date | Date[] | undefined>(undefined)
  const [issue_date_betweenD, setissue_date_betweenD] = useState<Date | Date[] | undefined>(
    undefined
  )

  const [expiration_date_date, setexpiration_date_date] = useState<Date | Date[] | undefined>(
    undefined
  )
  const [expiration_date_dateD, setexpiration_date_dateD] = useState<Date | Date[] | undefined>(
    undefined
  )

  const [expiration_date_between, setexpiration_date_between] = useState<Date | Date[] | undefined>(
    undefined
  )
  const [expiration_date_betweenD, setexpiration_date_betweenD] = useState<
    Date | Date[] | undefined
  >(undefined)

  const [limit_renovation, setlimit_renovation] = useState<Date | Date[] | undefined>(undefined)
  const [limit_renovationD, setlimit_renovationD] = useState<Date | Date[] | undefined>(undefined)

  const [limit_renovation_between, setlimit_renovation_between] = useState<
    Date | Date[] | undefined
  >(undefined)
  const [limit_renovation_betweenD, setlimit_renovation_betweenD] = useState<
    Date | Date[] | undefined
  >(undefined)

  const API_URL = process.env.REACT_APP_API_URL || 'api'

  interface UseOption {
    readonly value: string
    readonly label: string
    readonly color: string
    readonly isFixed?: boolean
    readonly isDisabled?: boolean
  }

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})
  }

  const filterData = () => {
    updateState({
      filter: {
        project_id,
        entrepreneur_id,
        status,
        field_id,
        license_number,
        license_type_id,
        enterprise_type_id,
        enterprise_id,
        description,
        entrepreneur_name,
        renovation_protocol,
        issue_date,
        issue_date_between,
        expiration_date_date,
        expiration_date_between,
        limit_renovation,
        limit_renovation_between,
      },
      ...initialQueryState,
    })
  }

  const openFilter = () => {
    if (openFilterWin === false) {
      setOpenFilterWin(true)
    } else {
      setOpenFilterWin(false)
    }
  }

  const openDLimit = () => {
    if (openDatelimit === false) {
      setOpenDatelimit(true)
    } else {
      setOpenDatelimit(false)
    }
  }

  const openDExp = () => {
    if (openDateexp === false) {
      setOpenDateexp(true)
    } else {
      setOpenDateexp(false)
    }
  }

  const openDEmi = () => {
    if (openDateemi === false) {
      setOpenDateemi(true)
    } else {
      setOpenDateemi(false)
    }
  }

  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      var projects: any = []
      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const project: any = {
              value: Response[i].id,
              label: Response[i].code,
            }
            projects.push(project)
          }
        }
      }
      callback(projects)
    }, 1000)
  }

  const loadOptionsEnterprises_Types = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getEnterprises_Types()
      var enterprises: any = []
      async function getEnterprises_Types() {
        const {data} = await axios.get(API_URL + '/v1/enterprise_types/select2')
        let Response = data.results

        for (var i = 0; i < Response.length; i++) {
          const enterprise: any = {
            value: Response[i].id,
            label: Response[i].name,
          }

          enterprises.push(enterprise)
        }
      }
      callback(enterprises)
    }, 1000)
  }

  const loadOptionsEntrepreneurs = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getentrepreneur()
      var entrepreneur: any = []
      async function getentrepreneur() {
        const {data} = await axios.get(API_URL + '/v1/entrepreneurs/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const field: any = {
              value: Response[i].id,
              label: Response[i].name,
            }

            entrepreneur.push(field)
          }
        }
      }
      callback(entrepreneur)
    }, 1000)
  }

  const loadOptionsFields = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getFields()
      var fields: any = []
      async function getFields() {
        const {data} = await axios.get(API_URL + '/v1/fields/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const field: any = {
              value: Response[i].id,
              label: Response[i].name,
            }

            fields.push(field)
          }
        }
      }
      callback(fields)
    }, 1000)
  }

  const loadOptionsEnterprises = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getenterprises()
      var enterprises: any = []
      async function getenterprises() {
        const {data} = await axios.get(API_URL + '/v1/enterprises/select2')
        let Response = data.results
        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const enterprise: any = {
              value: Response[i].id,
              label: Response[i].text,
            }

            enterprises.push(enterprise)
          }
        }
      }
      callback(enterprises)
    }, 1000)
  }

  const setConvertDate = (e: any, type: string, period: 'start' | 'conclusion' | 'limit') => {
    switch (period) {
      case 'start': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          console.log(DateFormate)
          setissue_date(DateFormate)
          setissue_dateD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }
          console.log(DateFormate)

          setissue_date_between(DateFormate)
          setissue_date_betweenD(e)
        }
        break
      }
      case 'conclusion': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          setexpiration_date_date(DateFormate)
          setexpiration_date_dateD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }
          setexpiration_date_between(DateFormate)
          setexpiration_date_betweenD(e)
        }
        break
      }
      case 'limit': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          setlimit_renovation(DateFormate)
          setlimit_renovationD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }
          setlimit_renovation_between(DateFormate)
          setlimit_renovation_betweenD(e)
        }

        break
      }
    }
  }
  addLocale('pt', {
    firstDayOfWeek: 1,
    dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'],
    monthNames: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    monthNamesShort: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    today: 'Hoje',
    clear: 'Limpar',
  })
  locale('pt')
  return (
    <>
      <div className='card-body py-1 p-0 '>
        {/* INICIO LINHA FIXA DO FILTRO */}
        <div className='row'>
          <div className='col-lg-3'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'PROJECT.PROJECT_TITLE'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='project_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsProjects}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'PROJECT.PROJECT_TITLE'})
                }
                onChange={(e: any) => {
                  setproject_id(e.value)
                }}
              />
            </div>
          </div>

          <div className='col-lg-4'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='field_id'
                styles={colourStyles}
                isMulti
                components={animatedComponents}
                cacheOptions
                loadOptions={loadOptionsFields}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})
                }
                onChange={(e: any) =>
                  e.length > 0 ? setfield_id(e.map((item: any) => item.value)) : setfield_id([''])
                }
              />
            </div>
          </div>

          <div className='col-lg-5'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'ENTERPRISES.TITLE'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='enterprise_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsEnterprises}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'ENTERPRISES.TITLE'})
                }
                onChange={(e: any) => setenterprise_id(e.value)}
              />

              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-primary btn-active-primary p-3 m-1'
                onClick={openFilter}
                title='Mais Filtros'
              >
                <i className='bi bi-sliders2-vertical fs-2' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-danger p-3 m-1'
                onClick={openFilter}
                title='Limpar'
              >
                <KTSVG path='/media/icons/duotune/art/art004.svg' className='svg-icon-3' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-primary m-1'
                onClick={filterData}
                title='Filtar'
              >
                {intl.formatMessage({id: 'COMMON.SEARCH'})}
              </button>
            </div>
          </div>
        </div>
        {/* FIM LINHA FIXA DO FILTRO */}

        {/* INICIO FILTRO RETRATIL FIXA DO FILTRO */}
        {/* LINHA 1 */}
        {openFilterWin && (
          <AnimaCima2>
            <div className='row mt-2'>
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'PROPERTIES.TYPE_CONTRACT'})}
                </label>
                <div className='d-flex position-relative my-1'>
                  <select
                    className='form-control form-control-solid fs-7 ps-6'
                    data-kt-select2='true'
                    onChange={(e) => setstatus(e.target.value)}
                    defaultValue='all'
                  >
                    <option value='all'>{intl.formatMessage({id: 'COMMON.ALL'})}</option>
                    <option value=''>Servidão</option>
                    <option value=''>Participação</option>
                    <option value=''>Dano direto</option>
                  </select>
                </div>
              </div>

              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'PROPERTIES.PARTICIPATION_SITUATION'})}
                </label>
                <div className='d-flex position-relative my-1'>
                  <select
                    className='form-control form-control-solid fs-7 ps-6'
                    data-kt-select2='true'
                    onChange={(e) => setstatus(e.target.value)}
                    defaultValue='all'
                  >
                    <option value='all'>{intl.formatMessage({id: 'COMMON.ALL'})}</option>
                    <option value=''>Regular</option>
                    <option value=''>Não Regular</option>
                    <option value=''>Sem informação</option>
                  </select>
                </div>
              </div>
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'PROPERTIES.SITUATION_SERVITUDE'})}
                </label>
                <div className='d-flex position-relative my-1'>
                  <select
                    className='form-control form-control-solid fs-7 ps-6'
                    data-kt-select2='true'
                    onChange={(e) => setstatus(e.target.value)}
                    defaultValue='all'
                  >
                    <option value='all'>{intl.formatMessage({id: 'COMMON.ALL'})}</option>
                    <option value=''>Regular</option>
                    <option value=''>Não Regular</option>
                    <option value=''>Sem informação</option>
                  </select>
                </div>
              </div>
            </div>
          </AnimaCima2>
        )}

        {/* LINHA 3 */}
        {openFilterWin && (
          <AnimaCima2>
            <div className='row mt-2'>
              <div className='col-lg-3'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='text'
                    data-kt-user-table-filter='license_type_id'
                    className='form-control form-control-solid fs-7 ps-6'
                    placeholder={
                      intl.formatMessage({id: 'COMMON.SEARCH'}) +
                      ' ' +
                      intl.formatMessage({id: 'COMMON.SEARCH'})
                    }
                    onChange={(e) => setlicense_type_id(e.target.value)}
                  />
                </div>
              </div>
              <div className='col-lg-3'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'PROPERTIES.REGISTER'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='text'
                    data-kt-user-table-filter='license_type_id'
                    className='form-control form-control-solid fs-7 ps-6'
                    placeholder={
                      intl.formatMessage({id: 'COMMON.SEARCH'}) +
                      ' ' +
                      intl.formatMessage({id: 'COMMON.SEARCH'})
                    }
                    onChange={(e) => setlicense_type_id(e.target.value)}
                  />
                </div>
              </div>
              <div className='col-lg-3'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.INPUT_CNPJ'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='text'
                    data-kt-user-table-filter='license_number'
                    className='form-control form-control-solid fs-7 ps-6'
                    placeholder={intl.formatMessage({id: 'COMMON.SEARCH'}) + ' ' + 'CNPJ/CPF'}
                    onChange={(e) => setlicense_number(e.target.value)}
                  />
                </div>
              </div>

              <div className='col-lg-3'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='text'
                    data-kt-user-table-filter='renovation_protocol'
                    className='form-control form-control-solid fs-7 ps-6'
                    placeholder={
                      intl.formatMessage({id: 'COMMON.SEARCH'}) +
                      ' ' +
                      intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})
                    }
                    onChange={(e) => setrenovation_protocol(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </AnimaCima2>
        )}
      </div>
    </>
  )
}

export {PropertiesListFilter}
